import './offlineStatus.scss';

const OfflineStatusViewer = ({ online }) => {
    return <div className={`offline-status${online ? '' : ' show'}`}>
        <small>OFFLINE</small>
    </div>
}

export default OfflineStatusViewer;